var formatIban = require('../utils/formatIban')

Ember.Handlebars.registerBoundHelper('formatIban', function(value, currencyCode) {
    if (!value) {
        return null
    }
    return formatIban(value, currencyCode)
})
